import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('property-sales-documents', storeModule.createStoreModule('property-sales-documents'))
